import { IconFolderOpenAngledOutline } from '@icons/IconFolderOpenAngledOutline'

import { Empty, EmptyContent, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from '@/components/shadcn/empty'

export function EmptyState({
  className,
  title,
  description,
  actions,
  icon,
  style,
}: {
  className?: string
  title?: string
  description?: string
  actions?: React.ReactNode
  icon?: React.ReactNode
  style?: React.CSSProperties
}) {
  return (
    <Empty style={style} className={className}>
      <EmptyHeader>
        <EmptyMedia variant="icon" className="text-foreground/65">
          {icon || <IconFolderOpenAngledOutline className="size-6" />}
        </EmptyMedia>
        <EmptyTitle className="text-base text-foreground/65">{title || 'Nothing results found...'}</EmptyTitle>
        {description && <EmptyDescription className="text-sm text-foreground/50">{description}</EmptyDescription>}
      </EmptyHeader>
      {actions && <EmptyContent>{actions}</EmptyContent>}
    </Empty>
  )
}
